'use client';

import React from 'react';
import { Logo } from '@/components/layout/Logo';

const ORG_DATA = {
  name: "News Afrika",
  legalName: "News Afrika (Pty) Ltd",
  abbreviation: "NA",
  logo: "https://newsafrika.com/logo.svg",
  founded: "2026",
  founder: "Nathaniel A. Bapela",
  headquarters: {
    city: "Pretoria",
    country: "South Africa"
  },
  industry: "Digital Media",
  website: "https://newsafrika.com",
  regNo: "2026/245624/07",
  wikidata: "https://www.wikidata.org/w/index.php?title=Q138662029&oldid=2476124512"
};

function InfoRow({ label, value, isLink = false }: { label: string; value: string; isLink?: boolean }) {
  return (
    <div className="grid grid-cols-[1fr_1.5fr] items-start border-t border-white/5 px-4 py-3 group hover:bg-white/[0.02] transition-colors">
      <div className="flex items-center">
        <span className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground whitespace-nowrap">{label}</span>
      </div>
      {isLink ? (
        <a 
          href={value} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-right text-xs font-medium text-[#8ab4f8] hover:underline break-all leading-relaxed pl-4"
        >
          {value.includes('wikidata') ? 'Q138662029' : value.replace('https://', '').replace('www.', '')}
        </a>
      ) : (
        <span className="text-right text-xs font-medium text-foreground/90 break-words leading-relaxed pl-4">
          {value}
        </span>
      )}
    </div>
  );
}

export function OrganizationInfobox() {
  return (
    <aside className="w-full border border-white/10 rounded-2xl overflow-hidden text-sm bg-[#0f0f0f] shadow-2xl sticky top-24">
      {/* Header */}
      <div className="bg-white/5 px-4 py-4 text-center border-b border-white/10">
        <h2 className="font-headline font-bold text-lg text-white tracking-tight uppercase">
          {ORG_DATA.name}
        </h2>
      </div>

      {/* Visual Identity */}
      <div className="p-8 flex justify-center bg-gradient-to-b from-white/[0.03] to-transparent">
        <div className="w-full h-12 relative flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-500">
           <Logo className="h-10 w-auto" />
        </div>
      </div>

      {/* Structured Data Rows */}
      <div className="flex flex-col">
        <InfoRow label="Legal Name" value={ORG_DATA.legalName} />
        <InfoRow label="Abbr." value={ORG_DATA.abbreviation} />
        <InfoRow label="Founded" value={ORG_DATA.founded} />
        <InfoRow label="Founder" value={ORG_DATA.founder} />
        <InfoRow label="Industry" value={ORG_DATA.industry} />
        <InfoRow 
          label="HQ" 
          value={`${ORG_DATA.headquarters.city}, ${ORG_DATA.headquarters.country}`} 
        />
        <InfoRow label="Registration" value={ORG_DATA.regNo} />
        <InfoRow label="Wikidata" value={ORG_DATA.wikidata} isLink={true} />
        
        <div className="grid grid-cols-[1fr_1.5fr] items-center border-t border-white/5 px-4 py-3 bg-primary/5">
          <span className="text-[11px] font-bold uppercase tracking-wider text-primary">Official Site</span>
          <a 
            href={ORG_DATA.website} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-right text-xs font-black text-white hover:underline truncate hover:text-primary transition-colors"
          >
            newsafrika.com
          </a>
        </div>
      </div>
      
      {/* Footer Branding */}
      <div className="p-3 bg-black/40 text-center border-t border-white/5">
         <span className="text-[9px] font-bold uppercase tracking-[0.2em] text-zinc-600">
           Verified Entity Profile
         </span>
      </div>
    </aside>
  );
}
